/**
 * アンカーリンク
 */
import { parse } from 'querystring'
import utils from '@/_modules/utils';
import {gsap, Quart, Cubic} from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

export default class SetAnchor {
  constructor() {
    // アンカーリンクボタンの設定
    this.anchors = document.querySelectorAll('.is-anchor-link');
    if (this.anchors.length > 0) {
      this.init();
    }

    // クエリアでアンカースクロール
    // DOMのid命名「block--*****」、クエリで「anchor=*****」
    const query = parse(location.search.slice(1));
    if (query['anchor'] !== undefined && document.getElementById('block--' + query['anchor'])) {
      const targetBlock = document.getElementById('block--' + query['anchor']);
      const offset = utils.getOffsetTop(targetBlock);
      this.scrollto(offset.top);
    }
  }

  init() {
    this.anchors.forEach((btn, i) => {
      btn.addEventListener('click', this.clickAnchor.bind(this, btn.hash.replace('#', '')));
    });
  }

  clickAnchor(id, e) {
    e.preventDefault();
    const offset = utils.getOffsetTop(document.getElementById('block--' + id));
    this.scrollto(offset.top);
  }

  scrollto(scrollY) {
    if (scrollY === undefined) return false;
    gsap.to(window, {
      duration: 0.7,
      scrollTo: {y: scrollY, autoKill: false},
      ease: Cubic.easeOut,
    });
  }
}
